(() => {
	'use strict';

	$(() => {
		// Accessibility tools
		toolsContrast();
		toolsFontSize();

		// Report tools
		toolsSearch();
		toolsSidebarToggle();
		toolsHighlighter();
		toolsNotes();
		toolsPrintBasket();
	});
})();
